module.exports = __webpack_public_path__ + "img/AIC-front.4ef63e65.jpg";